import { render, staticRenderFns } from "./RepairedButUnreleasedUsersList.vue?vue&type=template&id=bbf8118a&scoped=true"
import script from "./RepairedButUnreleasedUsersList.vue?vue&type=script&lang=js"
export * from "./RepairedButUnreleasedUsersList.vue?vue&type=script&lang=js"
import style0 from "./RepairedButUnreleasedUsersList.vue?vue&type=style&index=0&id=bbf8118a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bbf8118a",
  null
  
)

export default component.exports